import type { ClientDto } from '@fos/shared/contracts/crm';
import { MeetingRows } from './MeetingRows';

/**
 * Zakładka „Spotkania” w profilu klienta (slot `setClientTab('meetings', ClientMeetingsTab)` — podpina kompozycja).
 * Klient w trybie częściowym (tylko projekt albo zasób) widzi spotkania swoich projektów, bez „Nowe spotkanie”.
 */
export function ClientMeetingsTab({ client }: { client: ClientDto }) {
  return <MeetingRows clientId={client.id} allowAdd={!client.partial && client.canEdit} />;
}
